// extracted by mini-css-extract-plugin
export default {"header":"_2j2XbZCBzeu0xvX3I5ebyI","subtitle":"_2FBN3lJs5RRfmImAsm5qYk","backButton":"_1Lx3amvyWo7bkNRrJflYSv"};